export default __webpack_public_path__ + "static/media/contextual-chocolate@2x.80b1a042.png";